import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation DeleteSkillsDirectory($id: Int) {
  deleteRequestTypeDirectory(id: $id) {
    id
  }
}`;

function deleteSkillsDirectory(id) {
  return apollo.client.mutate({
    mutation,
    variables: { id: parseInt(id, 10) },
  }).then((res) => res.data.deleteRequestTypeDirectory);
}

export default deleteSkillsDirectory;
